export const successMessage = {
  auth: {
    id: {
      ko: '사용 가능한 아이디입니다.',
      en: 'Username is available.',
    },
    auth: '인증이 완료되었습니다.',
  },
  apply: {
    pay: '신청확인/결제 페이지에서 참가비 결제를 하셔야 참가 신청이 완료됩니다.',
    complete: '마라톤 참가신청이 완료되었습니다.',
  },
  password: '가입된 이메일로 비밀번호를 전송하였습니다.',
  confirm: '개인정보 수정이 완료되었습니다.',
  cancel: '환불 및 참가신청이 취소되었습니다.',
  code: '사용 가능한 코드입니다.',
};

export const errorMessage = {
  auth: {
    id: {
      ko: '이미 사용중인 아이디입니다.',
      en: 'This ID is already taken.',
    },
    duplicate: '이미 신청된 사용자입니다.',
    email: {
      duplicate: '이미 신청된 사용자거나, 중복된 이메일 주소입니다.',
      subsDuplicate: '이미 인증된 이메일입니다.',
      format: '이메일 형식이 맞지 않습니다.',
      error: '유효하지 않은 이메일이거나, 구독자가 아닌 이메일입니다.',
    },
    chosun: '조선닷컴에 가입한 이메일이 아닙니다.',
    error: '참가신청에 오류가 발생했습니다.',
    password: '올바른 정보를 입력해주세요.',
    jumin: '주민번호 형식이 맞지 않습니다.',
    impossible: '사용할 수 없는 아이디입니다.',
  },
  apply: {
    finish: {
      course: '선택한 코스가 마감되었습니다.',
      apply: '참가신청이 전부문 선착순 마감되었습니다. 성원에 감사드립니다.',
    },
    error: '참가신청에 실패했습니다.',
    code: {
      ko: '사용 가능한 코드가 아닙니다.',
      en: 'The code is not available.',
      input: '코드를 입력해주세요.',
    },
    half: '18세 미만 참가자는 하프코스 신청이 불가능합니다.',
    input: {
      info: '참가자 정보를 입력해주세요.',
      input: '참가신청 내역을 올바르게 적어주세요.',
      empty: '참가신청 내역이 없습니다.',
    },
    password: '비밀번호가 일치하지 않습니다. 다시 입력해주세요.',
  },
  record: {
    // 기록 조회에서 입력했는데 조회결과 없는경우 알럿
    empty: '조회 결과가 없습니다.',
    // 기록 조회 서버 500 에러 알럿
    error: '기록 조회에 실패했습니다.',

    format: '기록 형식이 맞지 않습니다.',
  },
  confirm: {
    // 참가 신청 내역은 있지만 정보를 틀리게 입력했을 경우 알럿
    fix: '참가신청 내역을 올바르게 적어주세요.',
    // 참가 신청 내역이 없을 때 알럿
    empty: '참가신청 내역이 없습니다.',
    // 신청 조회 서버 500 에러 알럿
    error: '참가신청 조회에 실패했습니다.',
    change: {
      // 수정하기 서버 500 에러 알럿
      error: '개인정보 수정에 실패했습니다.',
      // 참가신청 마감 알럿
      finish: '정보수정 기간이 종료되었습니다. 서울하프마라톤 사무국 (02)724-6333~6336, 02)785-0582~0583)으로 문의 부탁드립니다.',
      cancel: '취소/환불 기간이 종료되었습니다. 서울하프마라톤 사무국 (02)724-6333~6336, 02)785-0582~0583)으로 문의 부탁드립니다.',
    },
  },
  // 서버 500 오류 알럿
  server: 'Server Error',
  input: {
    // 내국인 입력 안했을때
    ko: '필수 항목을 입력해주세요.',
    // 외국인 입력 안했을때
    en: 'Please enter it as required.',
  },
  format: {
    // input 박스에 형식에 안맞게 입력했을때
    ko: '올바르지 않은 형식입니다.',
    en: 'Invalid format.',
  },
  // 법정대리인 판별
  deari: '14세 미만 참가자는 법정대리인의 동의가 필요합니다.',
  // 참가신청 마감 알럿
  period: '참가신청 기간이 아닙니다.',
  // 동의 페이지 판별 알럿
  agree: '참가자 유의사항에 동의해주세요.',
  // 기타 알럿
  etc: '궁금하신 점은 사무국(02-724-6333)에 문의해주세요. (문구 수정 예정)',
  // 중복 이름 판별 알럿
  duplicate: '참가 신청에 실패했습니다.',
  passwordError: '비밀번호 조회에 실패했습니다.',
};
